import { Component, Input, OnInit } from '@angular/core';
import { UiService } from 'src/app/models/ui-service';
import { NavService } from 'src/app/services/nav.service';

@Component({
  selector: 'app-menu-item',
  templateUrl: './menu-item.component.html',
  styleUrls: ['./menu-item.component.scss'],
})
export class MenuItemComponent implements OnInit {
  @Input() item: UiService;
  @Input() rounded = true;
  constructor(
    public navService: NavService
  ) { }

  ngOnInit() {}

  get hasChildSelected() {
    return !!this.item.childreen.find(c => c.url === this.navService.currentUrl);
  }
}
